import { Loading } from 'components/core-v2/pages'
import { Navigate, useLocation } from 'react-router-dom'
import { PermissionName, User } from 'types/user'

import { PATH } from '../const'
import { useUser } from '../utilities/hooks/useUser'

interface RequireAuthProps {
  children: JSX.Element
  permissionRequired: PermissionName
  roles?: string[]
}
export const RequireAuth = ({ children, permissionRequired, roles }: RequireAuthProps) => {
  const { data: userData, isError, isSuccess } = useUser()
  const location = useLocation()

  // If the user request is successful
  if (isSuccess) {
    const user = new User(userData)

    // And the user has the permissions, show the page
    if (
      user.can(permissionRequired) &&
      (roles ? roles.some(role => user.roles.includes(role)) : true)
    ) {
      return children
    }

    // eslint-disable-next-line
    console.debug(
      `RequireAuth failed: permissionRequired=${permissionRequired}, from=${location}, to=${PATH.permissionsRequired}, roles=`,
      roles
    )

    // Or the user doesn't have the permissions, move the user to /permissions-required
    return <Navigate replace state={{ from: location }} to={PATH.permissionsRequired} />
    // return <b style={{ color: 'red' }}>RequireAuth.tsx should redirect to {PATH.permissionsRequired} due to lacking {permissionRequired} permission.</b>;
  }

  // If the user request fails, they're not logged in, move the user to /login
  if (isError) {
    return <Navigate replace state={{ from: location }} to={PATH.login} />
  }

  // If the user request is still fetching, show the loading spinner
  return <Loading />
}
